module.exports = __webpack_public_path__ + "img/device-guide.02c875db.png";